// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-card__label {
  width: 120px;
}

.schedule-card__input {
  /* width: 354.469px; */
}

.schedule-day-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}

.schedule-day-row .p-inputgroup {
  flex: 1 1;
  min-width: 120px;
}

.schedule-day-row .compact-input {
  width: 100%;
}

.schedule-day-row .p-inputgroup-addon {
  min-width: 2.5rem;
  justify-content: center;
}

.schedule-days-container {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

/* .schedule-dayItem-error {
  border: 1px red solid;
  border-radius: 6px;
  margin: -2px;
} */

.schedule-dayItem-error .p-inputgroup-addon {
  background: #e1a9a9;
}

.schedule-day-row--duplicate {
  border-left: 3px solid #dc2626;
  padding-left: 0.5rem;
  margin-left: -0.125rem;
  border-radius: 4px;
  background: rgba(254, 202, 202, 0.35);
}

.schedule-dayItem-duplicate .p-inputgroup-addon {
  background: #fecaca;
}

.schedule-dayItem-duplicate .p-inputtext,
.schedule-dayItem-duplicate .p-inputnumber-input,
.schedule-dayItem-duplicate input {
  background-color: #fee2e2 !important;
}

.schedule-day-header {
  display: flex;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-color-secondary);
  padding: 0 0.5rem;
}

.schedule-day-column {
  flex: 1 1;
  min-width: 0;
  padding: 0 0.5rem;
  text-align: center;
}

.schedule-day-column-actions {
  width: 40px; /* Ширина колонки с кнопкой удаления */
}

/* Выравнивание строк */
.schedule-day-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

/* Иконки в инпутах */
.schedule-day-row .p-inputgroup-addon {
  min-width: 2.5rem;
  justify-content: center;
}

/* Компактные инпуты */
.compact-input {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/ScheduleCard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;GAIG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW,EAAE,sCAAsC;AACrD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb","sourcesContent":[".schedule-card__label {\n  width: 120px;\n}\n\n.schedule-card__input {\n  /* width: 354.469px; */\n}\n\n.schedule-day-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.schedule-day-row .p-inputgroup {\n  flex: 1;\n  min-width: 120px;\n}\n\n.schedule-day-row .compact-input {\n  width: 100%;\n}\n\n.schedule-day-row .p-inputgroup-addon {\n  min-width: 2.5rem;\n  justify-content: center;\n}\n\n.schedule-days-container {\n  margin-top: 1rem;\n  padding: 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n}\n\n/* .schedule-dayItem-error {\n  border: 1px red solid;\n  border-radius: 6px;\n  margin: -2px;\n} */\n\n.schedule-dayItem-error .p-inputgroup-addon {\n  background: #e1a9a9;\n}\n\n.schedule-day-row--duplicate {\n  border-left: 3px solid #dc2626;\n  padding-left: 0.5rem;\n  margin-left: -0.125rem;\n  border-radius: 4px;\n  background: rgba(254, 202, 202, 0.35);\n}\n\n.schedule-dayItem-duplicate .p-inputgroup-addon {\n  background: #fecaca;\n}\n\n.schedule-dayItem-duplicate .p-inputtext,\n.schedule-dayItem-duplicate .p-inputnumber-input,\n.schedule-dayItem-duplicate input {\n  background-color: #fee2e2 !important;\n}\n\n.schedule-day-header {\n  display: flex;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-color-secondary);\n  padding: 0 0.5rem;\n}\n\n.schedule-day-column {\n  flex: 1;\n  min-width: 0;\n  padding: 0 0.5rem;\n  text-align: center;\n}\n\n.schedule-day-column-actions {\n  width: 40px; /* Ширина колонки с кнопкой удаления */\n}\n\n/* Выравнивание строк */\n.schedule-day-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n/* Иконки в инпутах */\n.schedule-day-row .p-inputgroup-addon {\n  min-width: 2.5rem;\n  justify-content: center;\n}\n\n/* Компактные инпуты */\n.compact-input {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
